import { createFileRoute } from "@tanstack/react-router"
import { userProfileViewStaticData } from "src/views/UserProfileView/constants"
import { UserProfileView } from "src/views/UserProfileView/UserProfileView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/accounts/profile")({
	component: UserProfileView,
	staticData: userProfileViewStaticData,
})
